<router-outlet></router-outlet>
<x-loader *ngIf="!(hideLoader$ | async)"></x-loader>
